import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent implements OnInit {

  content: string | undefined ;
  safeHtmlContent: SafeHtml | undefined;

  constructor(public bsModalRef:BsModalRef,
              public sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.safeHtmlContent=this.sanitizer.bypassSecurityTrustHtml(this.content!);
  }
}
